module.exports = __webpack_public_path__ + "media/favicon/favicon-16x16-56cc9c59.png";